// utils/formUtils.js

/**
 * Coerce any value into displayable text.
 * - Arrays → join by ", "
 * - Objects:
 *   • attach/image shapes → assetId || id
 *   • wrapped { value } → value (if scalar)
 *   • otherwise JSON.stringify as a last resort
 */
function toText(val) {
  if (val == null) return "";
  if (Array.isArray(val)) {
    return val.map(toText).filter(Boolean).join(", ");
  }
  if (typeof val === "object") {
    // Common attach/image
    if (val.assetId || val.id) return String(val.assetId || val.id);
    if (
      Object.prototype.hasOwnProperty.call(val, "value") &&
      typeof val.value !== "object" &&
      val.value != null
    ) {
      return String(val.value);
    }
    try { return JSON.stringify(val); } catch { return ""; }
  }
  return String(val);
}

/**
 * Replaces chips (placeholders) in a message with actual form responses.
 * - "builder" → leave chips as-is
 * - "final"   → replace chips with submitted answers; remove if blank
 *
 * Chips supported:
 *   <span data-field-id="...">…</span>
 *   <span data-ufi="...">…</span>
 */
export const replaceChipsWithValues = (message, submittedValues, mode) => {
  if (!message) return "";

  // Show raw chips in builder
  if (mode === "builder") return message;

  const parser = new DOMParser();
  const doc = parser.parseFromString(message, "text/html");

  // Support both id styles
  const chips = doc.querySelectorAll('span[data-field-id], span[data-ufi]');

  chips.forEach((chip) => {
    const fieldId = chip.getAttribute("data-field-id");
    const ufi     = chip.getAttribute("data-ufi");
    const key     = fieldId || ufi;
    if (!key) return;

    // Pull raw value; coerce to text safely, then trim
    const raw = submittedValues ? submittedValues[key] : undefined;
    const text = toText(raw).trim();

    if (!text) {
      // No answer → drop the chip span
      chip.remove();
    } else {
      // Replace the chip span with a plain text node (no HTML injection)
      chip.replaceWith(document.createTextNode(text));
    }
  });

  return doc.body.innerHTML;
};
